<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import { clickoutside } from '@svelte-put/clickoutside';
import * as m from '@app/paraglide/messages.js';

let showDropdown = $state(false);

const alignLeft = () => {
    applyAlignment('left', '', 'start');
}

const applyAlignment = (actionName, alignment, xPos) => {
    if (window.quillEditor){
        window.quillEditor.formatLine(0, 9999, 'align', alignment, "silent");
    }
    
    
    eventGroupState[projectState.selected].selected.forEach(eventIndex => {
        eventGroupState[projectState.selected].events[eventIndex].alignment = alignment || "left";
        eventGroupState[projectState.selected].events[eventIndex].xPos = xPos;
    });

    insertHistoryAction({
        name: actionName,
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });
    
    showDropdown = false;
}

const toggleDropdown = () => {
    showDropdown = !showDropdown;
}

const closeDropdown = () => {
    showDropdown = false;
}

const leftJustifyLeftPos = () => applyAlignment('left justify / left position', '', 'start');
const centerJustifyLeftPos = () => applyAlignment('center justify / left position', 'center', 'start');
const rightJustifyLeftPos = () => applyAlignment('right justify / left position', 'right', 'start');

let isDisabled = $derived(!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0);
</script>

<li class="nav-item" title={m.align_left_title()}>
    <div class="btn-group btn-group-sm" role="group" use:clickoutside onclickoutside={closeDropdown}>
        <button 
            type="button" 
            class="btn btn-link nav-link" 
            id="align-left-btn"
            aria-label={m.align_left_aria_label()}
            disabled={isDisabled}
            onclick={alignLeft}
        >
            <i class="bi bi-text-left"></i>
        </button>
        <button 
            type="button" 
            class="btn btn-link nav-link dropdown-toggle dropdown-toggle-split" 
            aria-expanded={showDropdown}
            disabled={isDisabled}
            onclick={toggleDropdown}
        >
            <span class="visually-hidden">{m.toggle_dropdown()}</span>
        </button>
        <ul class="dropdown-menu" class:show={showDropdown}>
            <li><a class="dropdown-item" href="#!/" onclick={leftJustifyLeftPos}>{m.align_left_left_justify_left_pos()}</a></li>
            <li><a class="dropdown-item" href="#!/" onclick={centerJustifyLeftPos}>{m.align_left_center_justify_left_pos()}</a></li>
            <li><a class="dropdown-item" href="#!/" onclick={rightJustifyLeftPos}>{m.align_left_right_justify_left_pos()}</a></li>
        </ul>
    </div>
</li>
<style>
    .dropdown-menu {
        position: relative;
        top: 30px;
        left: 15px;
    }
</style>
